import { Purchases as NativePurchases } from '@revenuecat/purchases-capacitor';
import { isNative } from './platform';

/**
 * Attach native purchases to our own user id, so the RevenueCat webhook can
 * resolve the billing owner against students/parents. Web identity comes from
 * the API's auth instead (Checkout Session metadata `rc_customer_id`).
 */
export async function identifyUser(userId: string): Promise<void> {
  if (!isNative()) return;
  await NativePurchases.logIn({ appUserID: userId });
}
